import React, { useEffect, useState, useRef, useCallback } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as Actions from 'redux/actions/index';

import DailyCheckInFilters from './components/DailyCheckInFilters';
import DailyCheckInTable from './components/DailyCheckInTable';

function DailyCheckIn({ actions }) {
  const [filters, setFilters] = useState({
    schoolId: { label: 'All Schools', value: '' },
    courseId: { label: 'All Courses', value: '' },
    atRisk: [],
    searchQuery: '',
    browser: '',
    device: '',
    isLoggedIn: '',
    isPinned: '',
  });

  const [page, setPage] = useState(1);
  const [limit] = useState(25);

  const [loading, setLoading] = useState(false);
  const [reportData, setReportData] = useState(null);

  const requestIdRef = useRef(0);

  const fetchReport = useCallback(async () => {
    try {
      setLoading(true);

      // Increment request ID for this fetch
      const currentRequestId = ++requestIdRef.current;

      const response = await actions.getDailyCheckInReport({
        schoolId: filters.schoolId.value,
        courseId: filters.courseId.value,
        searchQuery: filters.searchQuery,
        riskFilter: filters.atRisk.filter((r) => r).map((r) => r),
        page,
        limit,
        filters: {
          browser: filters.browser,
          device: filters.device,
          isLoggedIn: filters.isLoggedIn,
          isPinned: filters.isPinned,
        },
      });

      // Only update state if this is still the latest request
      if (currentRequestId === requestIdRef.current) {
        setReportData(response.dailyCheckInReport || null);
      }
    } catch (err) {
      const currentRequestId = requestIdRef.current;
      // Only update state if this is still the latest request
      if (currentRequestId === requestIdRef.current) {
        setReportData(null);
      }
    } finally {
      setLoading(false);
    }
  }, [actions, filters, page, limit]);

  useEffect(() => {
    fetchReport();
  }, [fetchReport]);

  return (
    <div className="daily-checkin">
      <DailyCheckInFilters
        filters={filters}
        setFilters={setFilters}
        setPage={setPage}
        actions={actions}
      />

      <DailyCheckInTable
        loading={loading}
        reportData={reportData}
        page={page}
        limit={limit}
        setPage={setPage}
        actions={actions}
        filters={filters}
        setFilters={setFilters}
      />
    </div>
  );
}

function mapStateToProps() {
  return {};
}

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(Actions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(DailyCheckIn);
